<template>
  <div id="DistributionEvaluation">
		<h2 style="font-size: 24px; color: #262626; font-weight: bold;">分发测评</h2>
		<div class="progressDetails">
			<a-tabs defaultActiveKey="1">
				<a-tab-pane tab="心理量表" key="1">
					<a-input style="width: 180px; margin: 0px 14px 24px 24px;" placeholder="搜索量表名称" v-model="inputValue"/>
					<a-config-provider :autoInsertSpaceInButton="false">
						<a-button @click="searchHandle(1)">查询</a-button>
					</a-config-provider>
					<a-table bordered :dataSource="allSurveysFilter" :columns="columns" :rowKey="row => row.ID">
						<div slot="operation" slot-scope="text, record">
							<span v-if="roleID === 1" style="color: #1890FF;cursor: pointer;margin-right: 24px;" @click="viewUndetected(record, 0)">分发测评</span>
							<a-tooltip v-else class="showHide">
								<template slot="title">仅限超级管理员使用</template>
								<span>分发测评</span>
							</a-tooltip>
							<!-- <span style="color: #1890FF;cursor: pointer;" @click="showDeleteConfirm(record)">量表介绍</span> -->
						</div>
					</a-table>
				</a-tab-pane>
				<!-- <a-tab-pane tab="认知游戏" key="2">
					<a-input style="width: 180px;  margin: 0px 14px 24px 24px;" placeholder="搜索游戏名称" v-model="inputValue"/>
					<a-config-provider :autoInsertSpaceInButton="false">
						<a-button @click="searchHandle(2)">查询</a-button>
					</a-config-provider>
					<a-table bordered :dataSource="gameGroupsFilter" :columns="columns1" :rowKey="row => row.GAME_ID">
						<div slot="operation" slot-scope="text, record">
							<span style="color: #1890FF;cursor: pointer;" @click="viewUndetected(record, 1)">分发测评</span>
						</div>
					</a-table>
				</a-tab-pane> -->
			</a-tabs>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
	name: 'DistributionEvaluation',
	data () {
		return {
			inputValue: null,
			allSurveysFilter: null,
			gameGroupsFilter: null,
			columns: [
				{
					title: '量表名称',
					dataIndex: 'SURVEY_TITLE',
					width: '40%',
					scopedSlots: { customRender: 'SURVEY_TITLE' },
				},
				{
					title: '量表类别',
					dataIndex: 'CATEGORY_TITLE',
					width: '30%',
					scopedSlots: { customRender: 'CATEGORY_TITLE' }
				},
				{
					title: '操作',
					key: 'operation',
					scopedSlots: { customRender: 'operation' }
				},
			],
			columns1: [
				{
					title: '游戏名称',
					dataIndex: 'GAME_SUMMARY',
					width: '40%',
					scopedSlots: { customRender: 'GAME_SUMMARY' },
				},
				{
					title: '游戏类别',
					dataIndex: 'GAME_CATEGORY',
					width: '30%',
					scopedSlots: { customRender: 'GAME_CATEGORY' }
				},
				{
					title: '操作',
					key: 'operation',
					scopedSlots: { customRender: 'operation' }
				}
			],
			roleID: null
		}
	},
	computed: {
		...mapState([
			'allSurveys'
			// 'gameGroups'
		])
	},
	methods: {
		...mapMutations([
			'setDistributeItem'
		]),
		...mapActions([
			'getAllSurveys',
			'getGradeClass'
			// 'getGameGroups'
		]),
		searchHandle (tab) { // 查询
			if (tab === 1) {
				this.allSurveysFilter = this.allSurveys.filter((item) => !this.inputValue ? true : ((item.SURVEY_TITLE.indexOf(this.inputValue) !== -1)))
			} else {
				this.gameGroupsFilter = this.gameGroups.filter((item) => !this.inputValue ? true : ((item.GAME_SUMMARY.indexOf(this.inputValue) !== -1)))
			}
		},
		async viewUndetected (item, type) { // 分发测评
            if (this.roleID === 1) {
				item.type = type
				this.setDistributeItem(item)
				await this.getGradeClass()
				this.$router.push('/evaluationList/distributionDetail')
			}
		}
	},
	async mounted () {
		this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
		await this.getAllSurveys()
		this.allSurveysFilter = this.allSurveys
		// await this.getGameGroups()
		// this.gameGroupsFilter = this.gameGroups
	}
}
</script>

<style>
#DistributionEvaluation {
  width: 100%;
  padding-bottom: 200px;
  box-sizing: border-box;
}
#DistributionEvaluation .progressDetails {
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  margin-top: 24px;
}
#DistributionEvaluation .ant-tabs-bar {
  margin: 0px 0px 24px 0px;
  padding: 0px 24px;
}
#DistributionEvaluation .ant-table-thead > tr > th, #DistributionEvaluation .ant-table-tbody > tr > td {
  padding: 16px 24px;
}
#DistributionEvaluation .ant-table-pagination.ant-pagination {
  margin: 16px 24px 16px 0px;
}
#DistributionEvaluation .showHide {
  color: #BFBFBF;
}
</style>
